// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimClaimGroupViewSearchModel {
    static getAttributeTypeMap() {
        return ClaimClaimGroupViewSearchModel.attributeTypeMap;
    }
}
ClaimClaimGroupViewSearchModel.discriminator = undefined;
ClaimClaimGroupViewSearchModel.additionalProperties = false;
ClaimClaimGroupViewSearchModel.attributeTypeMap = [
    {
        "name": "claimIds",
        "baseName": "claimIds",
        "type": "Array<number>"
    },
    {
        "name": "claimGroupIds",
        "baseName": "claimGroupIds",
        "type": "Array<number>"
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": "Array<string>"
    },
    {
        "name": "includeAdjustments",
        "baseName": "includeAdjustments",
        "type": "boolean"
    },
];
//# sourceMappingURL=claimClaimGroupViewSearchModel.js.map